import React, { useState } from "react";
import api from '../api/axiosInstance';
import { Container, Form, Button, Card, Alert } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import AppNavbar from "../components/AppNavbar";

const RegisterPage = () => {
  const navigate = useNavigate();

  // --- Form State ---
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    category: "",
  });

  // --- Onay Kutuları State (3 Kritik Grup) ---
  const [agreements, setAgreements] = useState({
    generalTerms: false,   // Üyelik, Gizlilik, KVKK, Çerez, Satış
    abroadConsent: false,  // Frankfurt/Yurtdışı Aktarım
    medicalConsent: false, // Tıbbi Sorumluluk Reddi
  });

  const [message, setMessage] = useState(null);

  // --- Handlers ---
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAgreementChange = (e) => {
    setAgreements({ ...agreements, [e.target.name]: e.target.checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Boş Alan Kontrolü
    if (!form.name || !form.email || !form.password || !form.phone || !form.category) {
      setMessage({ type: "danger", text: "Lütfen tüm alanları doldurunuz." });
      return;
    }

    // 2. Yasal Onay Kontrolü
    if (!agreements.generalTerms) {
      setMessage({ type: "danger", text: "Lütfen Genel Sözleşmeleri (Üyelik, Gizlilik vb.) onaylayınız." });
      return;
    }
    if (!agreements.abroadConsent) {
      setMessage({ type: "danger", text: "Kayıt olabilmek için Yurtdışı Veri Aktarımı onayı zorunludur." });
      return;
    }
    if (!agreements.medicalConsent) {
      setMessage({ type: "danger", text: "Lütfen Tıbbi Sorumluluk Reddi beyanını onaylayınız." });
      return;
    }

    try {
      // Backend'e gönderirken onay loglarını ekle
      const payload = {
        ...form,
        agreements_accepted: true,
        agreement_date: new Date().toISOString()
      };

      const res = await api.post("/auth/register", payload);

      setMessage({ type: "success", text: res.data.message });
      setTimeout(() => navigate("/login"), 2000);

    } catch (err) {
      setMessage({
        type: "danger",
        text: err.response?.data?.message || "Bir hata oluştu.",
      });
    }
  };

  // Link Stili (Tekrarı önlemek için)
  const linkStyle = { 
    color: "#2D8A7A", 
    fontWeight: "bold", 
    textDecoration: "none" 
  };

  return (
    <>
      <AppNavbar />

      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", padding: "40px 0" }}
      >
        <Card className="p-4 shadow-lg" style={{ width: "100%", maxWidth: "500px", borderRadius: "15px" }}>
          <h3 className="text-center mb-4" style={{ color: "#2D8A7A" }}>
            Üye Ol
          </h3>

          {message && <Alert variant={message.type}>{message.text}</Alert>}

          <Form onSubmit={handleSubmit}>
            {/* --- Kişisel Bilgiler --- */}
            <Form.Group className="mb-3">
              <Form.Label>Ad Soyad</Form.Label>
              <Form.Control type="text" name="name" value={form.name} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control type="email" name="email" value={form.email} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Şifre</Form.Label>
              <Form.Control type="password" name="password" value={form.password} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Telefon</Form.Label>
              <Form.Control type="text" name="phone" value={form.phone} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Meslek</Form.Label>
              <Form.Select name="category" value={form.category} onChange={handleChange} required>
                <option value="">Meslek Seçiniz</option>
                <option value="Eczacı">Eczacı</option>
                <option value="Hekim">Hekim</option>
                <option value="Akademisyen">Akademisyen</option>
                <option value="Yardımcı Eczacı">Yardımcı Eczacı</option>
                <option value="Öğrenci">Öğrenci</option>
              </Form.Select>
            </Form.Group>

            <hr />

            <h6 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
              Yasal Onaylar
            </h6>

            {/* 1. GRUP: GENEL SÖZLEŞMELER */}
            <Form.Check className="mb-3">
                <Form.Check.Input 
                    type="checkbox" 
                    name="generalTerms"
                    checked={agreements.generalTerms}
                    onChange={handleAgreementChange}
                    required
                />
                <Form.Check.Label style={{ fontSize: "0.85rem" }}>
                    <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>Üyelik Sözleşmesi</Link>,{' '}
                    <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>Mesafeli Satış Sözleşmesi</Link>,{' '}
                    <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>KVKK Aydınlatma Metni</Link>,{' '}
                    <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>Gizlilik Politikası</Link> ve{' '}
                    <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>Çerez Politikası</Link>'nı okudum ve onaylıyorum.
                </Form.Check.Label>
            </Form.Check>

            {/* 2. GRUP: YURTDIŞI AKTARIMI (Frankfurt) */}
            <div className="p-2 mb-3 bg-light border rounded">
                <Form.Check>
                    <Form.Check.Input 
                        type="checkbox" 
                        name="abroadConsent"
                        checked={agreements.abroadConsent}
                        onChange={handleAgreementChange}
                        required
                    />
                    <Form.Check.Label style={{ fontSize: "0.85rem" }}>
                        Verilerimin, hizmetin sağlanabilmesi için <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={linkStyle}>Açık Rıza Metni</Link> kapsamında yurtdışındaki (Almanya) sunucularda saklanmasına rıza gösteriyorum.
                    </Form.Check.Label>
                </Form.Check>
            </div>

            {/* 3. GRUP: TIBBİ SORUMLULUK */}
            <div className="p-2 mb-4 border rounded" style={{ borderColor: "#dc3545", backgroundColor: "#fff5f5" }}>
                <Form.Check>
                    <Form.Check.Input 
                        type="checkbox" 
                        name="medicalConsent"
                        checked={agreements.medicalConsent}
                        onChange={handleAgreementChange}
                        required
                    />
                    <Form.Check.Label style={{ fontSize: "0.85rem", color: "#842029" }}>
                        <Link to="/yasal-bilgiler" target="_blank" rel="noopener noreferrer" style={{ ...linkStyle, textDecoration: "underline", color: "#842029" }}>Tıbbi Sorumluluk Reddi</Link> metnini okudum. Uygulamanın tıbbi tavsiye vermediğini, bilgilendirme amaçlı olduğunu ve mesleki sorumluluğun tarafıma ait olduğunu kabul ediyorum.
                    </Form.Check.Label>
                </Form.Check>
            </div>

            <Button type="submit" className="w-100 btn-primary" style={{ backgroundColor: "#2D8A7A", borderColor: "#2D8A7A" }}>
              Kayıt Ol
            </Button>

            <div className="text-center mt-3">
              <Link to="/login" style={{ color: "#2D8A7A" }}>
                Zaten hesabın var mı? Giriş yap
              </Link>
            </div>
          </Form>
        </Card>
      </Container>
    </>
  );
};

export default RegisterPage;